import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpHeaderConstants } from '@r1-compass-library/constants';
import {
    SalesforceListFieldResponse,
    SalesforceListObjectResponse,
} from '@r1-compass-library/models/salesforce/salesforce-response.model';
import { catchError, finalize, Observable, of, retry } from 'rxjs';
import { SpinnerService } from './spinner.service';
import { Environment } from '@r1-compass-library/environments/environment';

@Injectable({ providedIn: 'root' })
export class SalesforceService {
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);

    private BASE_URL: string = Environment.baseUrl + '/sf';

    getObjects(): Observable<SalesforceListObjectResponse> {
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams(),
        };

        const process = 'SalesforceService.getObjects';
        this.#spinnerService.addProcess(process, 'Getting salesforce objects...');
        return this.#http.get<SalesforceListObjectResponse>(`${this.BASE_URL}/sobjects`, httpOptions).pipe(
            retry(0),
            catchError(() => {
                return of<SalesforceListObjectResponse>();
            }),
            finalize(() => this.#spinnerService.completeProcess(process))
        );
    }

    getFieldsForObject(object: string): Observable<SalesforceListFieldResponse> {
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams(),
        };

        const process = 'SalesforceService.getFieldsForObject';
        this.#spinnerService.addProcess(process, 'Getting salesforce object fields...');
        return this.#http.get<SalesforceListFieldResponse>(`${this.BASE_URL}/describe/${object}`, httpOptions).pipe(
            retry(0),
            catchError(() => {
                return of<SalesforceListFieldResponse>();
            }),
            finalize(() => this.#spinnerService.completeProcess(process))
        );
    }
}
